import axios from "axios";

// On custom domains the baked build URL may point at the original host; the
// platform ingress routes /api on whatever host serves the page, so same-origin
// is always correct there (avoids CORS and third-party-cookie issues entirely).
const envUrl = process.env.REACT_APP_BACKEND_URL;
let base = envUrl || window.location.origin;
try {
  if (
    envUrl &&
    new URL(envUrl).origin !== window.location.origin &&
    !window.location.hostname.includes("localhost")
  ) {
    base = window.location.origin;
  }
} catch {
  base = window.location.origin;
}

export const api = axios.create({
  baseURL: `${base}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

// Traffic-source classification: category enum ONLY — the raw referrer URL is
// classified in the browser and never sent to or stored by the server.
export function srcCategory(ref) {
  if (ref === "pink") return "pink";
  let h = "";
  try {
    h = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : "";
  } catch { h = ""; }
  if (!h || h === window.location.hostname) return "direct";
  if (h === "lnkd.in" || h === "linkedin.com" || h.endsWith(".linkedin.com")) return "linkedin";
  if (h === "t.co" || /(^|\.)(facebook|instagram|twitter|x|threads|youtube|tiktok)\.(com|net)$/.test(h))
    return "other_social";
  if (/(^|\.)(google|bing|duckduckgo|yahoo|ecosia|qwant|yandex|baidu)\.[a-z.]+$/.test(h)) return "search";
  return "other";
}

// Source category of the current tab-session (enum only; never a raw URL).
// Attached to every session event so qualified/engaged source attribution is
// deterministic even when the visit ping loses the race against engagement.
function currentSrcCat() {
  try { return srcCategory(sessionStorage.getItem("pg_ref") || null); } catch { return null; }
}

// Aggregate-only session-stage funnel ping (anonymous 24h session id, no identifiers)
export function trackStage(event) {
  try {
    const sid = sessionStorage.getItem("pg_sid");
    const src_cat = currentSrcCat();
    api.post("/analytics/event", { event, ...(sid ? { sid } : {}), ...(src_cat ? { src_cat } : {}), path: window.location.pathname }).catch(() => {});
  } catch { /* private mode */ }
}

// Anonymous 24h session id (set by Layout on first visit) — never joined to accounts
export function getSid() {
  try { return sessionStorage.getItem("pg_sid"); } catch { return null; }
}

// Aggregate event ping (cta views/clicks etc.) — counters only, no identifiers/URLs
export function trackEvent(event, extra = {}) {
  try {
    const sid = sessionStorage.getItem("pg_sid");
    const src_cat = currentSrcCat();
    api.post("/analytics/event", { event, ...(sid ? { sid } : {}), ...(src_cat ? { src_cat } : {}), path: window.location.pathname, ...extra }).catch(() => {});
  } catch { /* private mode */ }
}

// PWA install = strong product-engagement signal; idempotent per browser session
// (server additionally dedupes per session-day).
export function trackPwaInstall() {
  try {
    if (sessionStorage.getItem("pg_pwa_inst")) return;
    sessionStorage.setItem("pg_pwa_inst", "1");
    trackEvent("pwa_install");
  } catch { /* private mode */ }
}
